import { render, staticRenderFns } from "./review-block.vue?vue&type=template&id=0b560492"
import script from "./review-block.vue?vue&type=script&lang=js"
export * from "./review-block.vue?vue&type=script&lang=js"
import style0 from "./review-block.vue?vue&type=style&index=0&id=0b560492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports